var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_10692969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.234 17.7244C26.5301 15.4793 22.4762 10.711 16.1791 7.0752C9.88009 3.43945 3.72471 2.31238 2.42859 4.55745C1.70871 5.80088 0.99065 7.04613 0.272588 8.29138C-1.02354 10.5365 3.03034 15.3029 9.32928 18.9388C15.6265 22.5745 21.7836 23.7034 23.0798 21.4583C23.7978 20.2131 24.5159 18.9696 25.234 17.7244Z",
    fill: "#FE9923"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2334 17.7244C26.2224 16.0138 24.1009 12.8361 20.2488 9.81299C19.2072 10.2984 18.1437 10.851 17.0766 11.4672C13.3318 13.6287 10.2868 16.1429 8.44531 18.4134C8.73438 18.5915 9.02888 18.7661 9.32881 18.9387C12.8119 20.9493 16.2513 22.1927 18.8491 22.5236C20.0125 21.9964 21.205 21.3856 22.403 20.6948C22.9956 20.3512 23.5701 20.0004 24.1264 19.6422L25.2334 17.7244Z",
    fill: "#CE7C1D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1793 7.07526C9.88034 3.43944 3.72496 2.31238 2.42884 4.55744C1.13271 6.80069 5.18659 11.569 11.4855 15.2048C17.7827 18.8406 23.9398 19.9695 25.2342 17.7244C26.5303 15.4793 22.4765 10.711 16.1793 7.07526Z",
    fill: "#FECD3D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5977 15.2703C17.8567 18.8534 23.9465 19.955 25.2336 17.7244C26.2225 16.0138 24.101 12.8361 20.249 9.81299C19.2073 10.2984 18.1438 10.851 17.0768 11.4672C15.008 12.6598 13.1537 13.9614 11.5977 15.2703Z",
    fill: "#CEA732"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0804 8.97496C10.0703 6.08265 5.44921 4.70652 4.7584 5.90271C4.0694 7.0989 7.57065 10.4129 12.5808 13.3051C17.5909 16.1974 22.212 17.5735 22.9027 16.3774C23.5935 15.183 20.0905 11.869 15.0804 8.97496Z",
    fill: "#FEA832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4727 13.8048C18.1283 16.3517 22.2548 17.5024 22.9038 16.3771C23.4438 15.441 21.415 13.2068 18.1047 10.8926C17.7629 11.078 17.4193 11.2689 17.0775 11.467C15.785 12.2124 14.578 12.9995 13.4727 13.8048Z",
    fill: "#CE8829"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.5145 21.033L19.611 22.5963C19.2275 22.5727 18.8185 22.5273 18.3912 22.4582L19.5402 20.4676L20.5145 21.033ZM7.12578 17.5627C7.43303 17.7699 7.74753 17.9753 8.06928 18.1771L9.11278 16.3701L8.13841 15.8102L7.12578 17.5627ZM1.01953 11.8617C1.23222 12.1835 1.47584 12.5143 1.75034 12.8507L2.89928 10.8619L1.92309 10.2983L1.01953 11.8617ZM3.87909 15.0485C4.15722 15.2957 4.44628 15.5448 4.74803 15.792L5.84241 13.8977L4.86803 13.3378L3.87909 15.0485ZM10.6162 19.6495C10.9543 19.8259 11.2906 19.9968 11.6233 20.1585L12.6358 18.4061L11.6615 17.8407L10.6162 19.6495ZM14.3447 21.3329C14.71 21.4711 15.07 21.5965 15.4227 21.7128L16.4116 20.0004L15.4372 19.4405L14.3447 21.3329Z",
    fill: "#C85929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.04772 18.6953V19.8333H4.18572V20.7314H3.04772V21.8694H2.14972V20.7314H1.01172V19.8333H2.14972V18.6953H3.04772Z",
    fill: "#FEA832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.1025 5.12451V6.2607H24.2405V7.15876H23.1025V8.2967H22.2044V7.15876H21.0664V6.2607H22.2044V5.12451H23.1025Z",
    fill: "#FEA832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76472 23.7087C5.46853 21.4636 9.52428 16.6971 15.8214 13.0613C22.1186 9.42377 28.2757 8.29665 29.5719 10.5418C30.29 11.787 31.008 13.0305 31.7279 14.2757C33.0241 16.5208 28.9683 21.2873 22.6712 24.9249C16.3722 28.5606 10.2169 29.6878 8.92072 27.4426C8.20266 26.1992 7.48278 24.954 6.76472 23.7087Z",
    fill: "#FE9923"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8214 13.0613C22.1186 9.42377 28.2757 8.29665 29.5719 10.5418C30.8681 12.7868 26.8123 17.5533 20.5152 21.1891C14.2162 24.8267 8.06091 25.9538 6.76472 23.7087C5.46853 21.4636 9.52422 16.6971 15.8214 13.0613Z",
    fill: "#FECD3D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9173 14.9613C21.9273 12.0672 26.5503 10.6929 27.2392 11.8872C27.93 13.0834 24.4288 16.3974 19.4168 19.2897C14.4068 22.1837 9.78571 23.5581 9.09671 22.3637C8.4059 21.1676 11.9071 17.8536 16.9173 14.9613Z",
    fill: "#FEA832"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.5617 25.4248L17.6543 27.3172C17.2889 27.4554 16.929 27.5827 16.5745 27.6972L15.5856 25.9847L16.5617 25.4248ZM19.3631 24.3905L20.3739 26.1429C20.7084 25.9811 21.0447 25.812 21.381 25.6339L20.3375 23.8269L19.3631 24.3905ZM11.4844 27.0173L12.386 28.5807C12.7714 28.5589 13.1786 28.5116 13.6076 28.4425L12.4587 26.4538L11.4844 27.0173ZM30.0741 16.2827L29.0997 16.8463L30.2467 18.835C30.5212 18.4988 30.7667 18.1697 30.9776 17.8479L30.0741 16.2827ZM22.8861 22.3545L23.9296 24.1633C24.2514 23.9597 24.5659 23.7543 24.8731 23.547L23.8606 21.7946L22.8861 22.3545ZM26.1566 19.8821L27.2509 21.7782C27.5527 21.5291 27.8417 21.2819 28.1181 21.0328L27.1309 19.3222L26.1566 19.8821Z",
    fill: "#C85929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.4b31c1ebc636cda79c57b8db4d3d1502.svg";
export { ForwardRef as ReactComponent };